import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderComponent } from '@swissfex/sfx-commons';

import { MAIN_ROUTES } from '../../constants';
import { RouterService } from '../../core/services/router.service';
import { DiagnosticsService } from '../../diagnostics/services/diagnostics.service';

@Component({
    templateUrl: './unmatched-route.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoaderComponent]
})
export class UnmatchedRouteComponent {
    private readonly diagnosticsSvc = inject(DiagnosticsService);
    private readonly routerSvc = inject(RouterService);

    constructor() {
        this.diagnosticsSvc.log({ key: 'unmatchedRoute', value: location.href });
        void this.routerSvc.navigateToRoute([MAIN_ROUTES.PROJECTS]);
    }
}
